/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShipmentDto } from '../../models/shipment-dto';

export interface ShipmentControllerFindByPigId$Params {
  pigId: string;
}

export function shipmentControllerFindByPigId(http: HttpClient, rootUrl: string, params: ShipmentControllerFindByPigId$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentDto>> {
  const rb = new RequestBuilder(rootUrl, shipmentControllerFindByPigId.PATH, 'get');
  if (params) {
    rb.path('pigId', params.pigId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShipmentDto>;
    })
  );
}

shipmentControllerFindByPigId.PATH = '/api/shipments/pig/{pigId}';
